export enum IntersectionType {
  HARD_CORNER = 'HARD_CORNER',
  MID_BLOCK = 'MID_BLOCK',
  SOFT_CORNER = 'SOFT_CORNER'
}
